import axios, { AxiosError } from 'axios'

export type UploadpathResponse = {
  parcelPath: string
  slipPath?: string
}
export const UPLOAD_PATH_TYPE = {
  PARCEL: 'parcel',
  BOTH: 'both',
} as const
export type UploadpathType = typeof UPLOAD_PATH_TYPE[keyof typeof UPLOAD_PATH_TYPE]

export const uploadpath = async (sessionId: string, type: UploadpathType): Promise<UploadpathResponse> => {
  try {
    const url = `${process.env.REACT_APP_API_SERVER}/v1/uploadpath/${type}`
    const response = await axios.get(url, { headers: { authorization: `Bearer ${sessionId}` } })

    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error as AxiosError)
  }
}
